import {Button, ButtonStyles, ButtonType} from "../../../lib/form/Button/Button";
import {LoginMode} from "../../Checkout";
import Spinner from "../../../utils/loader/Spinner";
import * as React from "react";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {useCartContext} from "../../../cart/CartContextProvider/CartContextProvider";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";
import {ICheckoutPutParams} from "../../../../typescript-library";
import {Payments} from "../../../lib/payments/PaymentController";

const RegisterCustomer: React.FC = () => {
  const {t} = useTranslation();
  const {checkout} = useCheckoutContext();
  const {viewState, setViewState} = useCartContext();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="container-right">
      <h3>{t("checkout.noAccountYet")}</h3>
      <p>{t("checkout.membershipBenefits")}</p>
      <div className="text checkmarks">
        <ul>
          <li>
            <i className="icon icon-check--lightgreen">&#160;</i>
            {t("checkout.receiveExclusiveOffers")}
          </li>
          <li>
            <i className="icon icon-check--lightgreen">&#160;</i>
            {t("checkout.manageOrdersInAccount")}
          </li>
        </ul>
      </div>
      <Button
        btnIdentifier={LoginMode.NEWCUSTOMER}
        type={isLoading ? ButtonType.disabled : ButtonType.outlined}
        action={(evt) => {
          evt.preventDefault();
          setViewState({...viewState, isRegistering: true});
          setIsLoading(true);
          const paramsToPut: ICheckoutPutParams = {
            isGuest: false,
          };
          if (
            [Payments.ApplePay, Payments.GooglePay, Payments.PaypalExpressBraintree].includes(
              checkout.paymentId as Payments,
            )
          ) {
            paramsToPut.paymentId = null;
          }
          void checkout.put(paramsToPut);
        }}
        styles={[ButtonStyles.wide]}
      >
        {isLoading ? <Spinner /> : <span> {t("customer.registerNow")}</span>}
      </Button>
    </div>
  );
};

export default RegisterCustomer;
